import React, { useEffect, useState } from 'react';
import BlastStatistics from './BlastStatistics';
import StopeStatistics from './StopeStatistics';
import { getSiteModules } from '../../config/siteConfig';

export default function SiteStatistics({ stopeID }) {
  const { openPit, underground } = getSiteModules();
  const [tab, setTab] = useState(openPit ? 'blasts' : 'stopes');

  useEffect(() => {
    if (openPit && !underground) setTab('blasts');
    else if (!openPit && underground) setTab('stopes');
  }, [openPit, underground]);

  if (!openPit && !underground) {
    return (
      <div className="p-3 text-[11px] text-zinc-500">
        No statistics modules are enabled for this site.
      </div>
    );
  }

  const showTabs = openPit && underground;

  return (
    <div className="flex flex-col h-full min-h-0">
      {showTabs && (
        <div className="flex shrink-0 border-b border-yellow-600/20">
          <button
            type="button"
            onClick={() => setTab('blasts')}
            className={`m-0 flex-1 px-2 py-1.5 text-[10px] uppercase tracking-wider ${
              tab === 'blasts' ? 'bg-yellow-500/15 text-yellow-400' : 'text-zinc-500 hover:text-zinc-300'
            }`}
          >
            Open pit
          </button>
          <button
            type="button"
            onClick={() => setTab('stopes')}
            className={`m-0 flex-1 px-2 py-1.5 text-[10px] uppercase tracking-wider ${
              tab === 'stopes' ? 'bg-yellow-500/15 text-yellow-400' : 'text-zinc-500 hover:text-zinc-300'
            }`}
          >
            Underground
          </button>
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-hidden">
        {tab === 'blasts' && openPit && (
          <div className="h-full overflow-auto bg-white text-gray-900">
            <BlastStatistics />
          </div>
        )}
        {tab === 'stopes' && underground && <StopeStatistics stopeID={stopeID} />}
      </div>
    </div>
  );
}
